export class RackZoneLocationRequest{
    rackId: number;
    zoneId: number;
    constructor(rackId:number,zoneId:number){
        this.rackId = rackId;
        this.zoneId = zoneId;
    }
}